var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgRemoveOutline = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "21px",
  height: "21px",
  viewBox: "0 0 21 21",
  xmlns: "http://www.w3.org/2000/svg",
  className: "react-svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10.5,0 C4.704,0 0,4.704 0,10.5 C0,16.296 4.704,21 10.5,21 C16.296,21 21,16.296 21,10.5 C21,4.704 16.296,0 10.5,0 Z M10.5,18 C6.365625,18 3,14.634375 3,10.5 C3,6.365625 6.365625,3 10.5,3 C14.634375,3 18,6.365625 18,10.5 C18,14.634375 14.634375,18 10.5,18 Z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 6,
  y: 9,
  width: 9,
  height: 3,
  rx: 1
})))));
export default SvgRemoveOutline;